<div class="modal">
    <div class="spinningContent">
        <fui-spinning-loader [height]="74" [width]="74"></fui-spinning-loader>
    </div>
</div>
